export const imports = {
  'SECURITY.md': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "security" */ 'SECURITY.md'
    ),
  'docs/explore/arg.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-explore-arg" */ 'docs/explore/arg.mdx'
    ),
  'docs/explore/duplex-type-and-duplex-field.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-explore-duplex-type-and-duplex-field" */ 'docs/explore/duplex-type-and-duplex-field.mdx'
    ),
  'docs/explore/input-type-and-input-field.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-explore-input-type-and-input-field" */ 'docs/explore/input-type-and-input-field.mdx'
    ),
  'docs/explore/interfaces.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-explore-interfaces" */ 'docs/explore/interfaces.mdx'
    ),
  'docs/explore/mixins.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-explore-mixins" */ 'docs/explore/mixins.mdx'
    ),
  'docs/explore/object-type-and-field.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-explore-object-type-and-field" */ 'docs/explore/object-type-and-field.mdx'
    ),
  'docs/explore/union.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-explore-union" */ 'docs/explore/union.mdx'
    ),
  'docs/getting-started/minimal-example.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-getting-started-minimal-example" */ 'docs/getting-started/minimal-example.mdx'
    ),
  'docs/getting-started/setup.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-getting-started-setup" */ 'docs/getting-started/setup.mdx'
    ),
  'docs/reference/api-reference.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-reference-api-reference" */ 'docs/reference/api-reference.mdx'
    ),
  'docs/explore/enum/enums.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-explore-enum-enums" */ 'docs/explore/enum/enums.mdx'
    ),
  'docs/explore/hooks/authorization-example.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-explore-hooks-authorization-example" */ 'docs/explore/hooks/authorization-example.mdx'
    ),
  'docs/explore/hooks/resolution-hooks.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-explore-hooks-resolution-hooks" */ 'docs/explore/hooks/resolution-hooks.mdx'
    ),
  'docs/explore/inject/Inject.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-explore-inject-inject" */ 'docs/explore/inject/Inject.mdx'
    ),
  'docs/explore/schema/Schema.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-explore-schema-schema" */ 'docs/explore/schema/Schema.mdx'
    ),
}
